import _lodash from 'lodash';

function toTitleCase(str) {
    return _lodash.startCase(_lodash.toLower(str));
}

export default toTitleCase;
